// extracted by mini-css-extract-plugin
export var accordionSection = "ArticleAccordionSection-module--accordionSection--1QClF";
export var titleWrapper = "ArticleAccordionSection-module--titleWrapper--1TbBY";
export var title = "ArticleAccordionSection-module--title--24EzU";
export var text = "ArticleAccordionSection-module--text--3WPz1";
export var collapsed = "ArticleAccordionSection-module--collapsed--AJEg8";